<template>
  <b-row cols="1" cols-md="12" cols-lg="12" cols-xl="5" class="directory text-center">
    <b-col class="boxes box0">
      <router-link :to="{ name: 'Chairman' }">
        <b-row class="box">
          <div class="icon"><img src="@/assets/01/btn_01.png" /></div>
          <b-col cols="6" lg="8" class="text zh-text" v-if="$i18n.locale == 'zh'">
            {{ $t("title.ChairmanMsg&ED") }}
          </b-col>
          <b-col cols="6" md="6" lg="8" class="text" v-else>
            {{ $t("title.ChairmanMsg&ED") }}
          </b-col>
        </b-row>
      </router-link>
    </b-col>
    <b-col class="boxes box1">
      <router-link :to="{ name: 'BoardMembers' }">
        <b-row class="box">
          <div class="icon"><img src="@/assets/01/btn_02.png" /></div>
          <b-col cols="6" lg="8" class="text zh-text" v-if="$i18n.locale == 'zh'">
            {{ $t("title.bms") }}
          </b-col>
          <b-col cols="6" md="6" lg="8" class="text" v-else>{{ $t("title.bms") }}</b-col>
        </b-row>
      </router-link>
    </b-col>
    <b-col class="boxes box2">
      <router-link :to="{ name: 'SupportToEconomy' }">
        <b-row class="box">
          <div class="icon"><img src="@/assets/01/btn_03.png" /></div>
          <b-col cols="6" lg="8" class="text zh-text" v-if="$i18n.locale == 'zh'">
            {{ $t("title.supportToEcon") }}
          </b-col>
          <b-col cols="6" md="6" lg="8" class="text" v-else>
            {{ $t("title.supportToEcon") }}
          </b-col>
        </b-row>
      </router-link>
    </b-col>
    <b-col class="boxes box3">
      <router-link :to="{ name: 'Initiatives' }">
        <b-row class="box">
          <div class="icon"><img src="@/assets/01/btn_04.png" /></div>
          <b-col cols="6" lg="8" class="text text-capitalize zh-text" v-if="$i18n.locale == 'zh'">
            {{ $t("title.init") }}
          </b-col>
          <b-col cols="6" md="6" lg="8" class="text text-capitalize" v-else>
            {{ $t("title.init") }}
          </b-col>
        </b-row>
      </router-link>
    </b-col>
    <b-col class="boxes box4">
      <router-link :to="{ name: 'AboutUs' }">
        <b-row class="box">
          <div class="icon"><img src="@/assets/01/btn_05.png" /></div>
          <b-col cols="6" lg="8" class="text zh-text" v-if="$i18n.locale == 'zh'">
            {{ $t("title.aboutUs") }}
          </b-col>
          <b-col cols="6" md="6" lg="8" class="text" v-else>
            {{ $t("title.aboutUs") }}
          </b-col>
        </b-row>
      </router-link>
    </b-col>
  </b-row>
</template>

<script>
export default {
  mounted() {},
};
</script>

<style lang="scss" scoped>
.directory {
  align-items: center;
}
.zh-text {
  font-weight: bold;
}
.text {
  line-height: 20px;
}
.boxes {
  &.box0 {
    background-color: #fe8931;
  }
  &.box1 {
    background-color: #eb0362;
  }
  &.box2 {
    background-color: #063151;
  }
  &.box3 {
    background-color: #34c7c2;
  }
  &.box4 {
    background-color: #e81b29;
  }
  a:hover {
    text-decoration: none;
  }
}
.box0:hover {
  background-color: #d17128;
}
.box1:hover {
  background-color: #c70353;
}
.box2:hover {
  background-color: #05253d;
}
.box3:hover {
  background-color: #2ba4a0;
}
.box4:hover {
  background-color: #ae141f;
}
.box {
  color: #fff;
  min-height: 75px;
  justify-content: center;
  align-items: center;
  .text {
    font-size: 20px;
  }
  .zh-text {
    font-size: 18px;
  }
}
@media (max-width: 767px) {
  .box {
    min-height: 60px;
    .text {
      font-size: 17px;
    }
  }
  .icon {
    img {
      width: 35px;
    }
  }
}
@media (max-width: 1400px) {
  .box {
    .zh-text {
      font-size: 15.9px;
    }
  }
  .icon {
    img {
      width: 38px;
    }
  }
}
</style>
